"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getEntityElement_1 = require("./getEntityElement");
var getEntityFromElement_1 = require("./getEntityFromElement");
var tryTriggerEntityEvent_1 = require("./tryTriggerEntityEvent");
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
var roosterjs_editor_core_1 = require("roosterjs-editor-core");
var EntityInfo_1 = require("./EntityInfo");
var EntityFeatures_1 = require("./EntityFeatures");
/**
 * Entity Plugin helps handle all operations related to an entity and generate entity specified events
 */
var EntityPlugin = /** @class */ (function () {
    function EntityPlugin() {
        var _this = this;
        this.handleContextMenuEvent = function (event) {
            var target = event.target;
            var entityElement = getEntityElement_1.default(_this.editor, target);
            if (entityElement) {
                event.preventDefault();
                tryTriggerEntityEvent_1.default(_this.editor, entityElement, 2 /* ContextMenu */, event);
            }
        };
        this.handleCutEvent = function (event) {
            var range = _this.editor.getSelectionRange();
            if (!range.collapsed) {
                _this.checkRemoveEntityForRange(event);
            }
        };
    }
    EntityPlugin.prototype.getName = function () {
        return 'Entity';
    };
    EntityPlugin.prototype.initialize = function (editor) {
        var _this = this;
        this.editor = editor;
        this.disposer = this.editor.addDomEventHandler({
            contextmenu: this.handleContextMenuEvent,
            cut: this.handleCutEvent,
        });
        this.knownEntityElements = [];
        [
            EntityFeatures_1.ClickOnEntityFeature,
            EntityFeatures_1.EscapeFromEntityFeature,
            EntityFeatures_1.EnterBeforeReadonlyEntityFeature,
            EntityFeatures_1.BackspaceAfterEntityFeature,
            EntityFeatures_1.DeleteBeforeEntityFeature,
        ].forEach(function (feature) { return _this.editor.addContentEditFeature(feature); });
    };
    EntityPlugin.prototype.dispose = function () {
        this.disposer();
        this.disposer = null;
        this.editor = null;
        this.knownEntityElements = null;
    };
    EntityPlugin.prototype.onPluginEvent = function (event) {
        switch (event.eventType) {
            case 4 /* MouseDown */:
                this.handleMouseDownEvent(event.rawEvent);
                break;
            case 5 /* MouseUp */:
                this.handleMouseUpEvent(event.rawEvent);
                break;
            case 0 /* KeyDown */:
                this.handleKeyDownEvent(event.rawEvent);
                break;
            case 9 /* BeforePaste */:
                this.handleBeforePasteEvent(event.fragment, event.sanitizingOption);
                break;
            case 6 /* ContentChanged */:
                this.handleContentChangedEvent(event.source == "SetContent" /* SetContent */);
                break;
            case 10 /* EditorReady */:
                this.handleContentChangedEvent(true /*resetAll*/);
                break;
            case 8 /* ExtractContentWithDom */:
                this.handleExtractContentWithDomEvent(event.clonedRoot);
                break;
        }
    };
    EntityPlugin.prototype.handleMouseDownEvent = function (event) {
        var target = event.target, pageX = event.pageX, pageY = event.pageY;
        var entityElement = getEntityElement_1.default(this.editor, target);
        if (entityElement && !entityElement.isContentEditable) {
            event.preventDefault();
            this.clickingPoint = { pageX: pageX, pageY: pageY };
        }
    };
    EntityPlugin.prototype.handleMouseUpEvent = function (event) {
        var target = event.target, pageX = event.pageX, pageY = event.pageY;
        var entityElement;
        if (this.clickingPoint &&
            this.clickingPoint.pageX == pageX &&
            this.clickingPoint.pageY == pageY &&
            !!(entityElement = getEntityElement_1.default(this.editor, target))) {
            event.preventDefault();
            tryTriggerEntityEvent_1.default(this.editor, entityElement, 1 /* Click */, event);
            workaroundSelectionIssueForIE(this.editor);
        }
        this.clickingPoint = null;
    };
    EntityPlugin.prototype.handleKeyDownEvent = function (event) {
        if (roosterjs_editor_core_1.isCharacterValue(event) ||
            event.which == 8 /* BACKSPACE */ ||
            event.which == 46 /* DELETE */) {
            var range = this.editor.getSelectionRange();
            if (!range.collapsed) {
                this.checkRemoveEntityForRange(event);
            }
        }
    };
    EntityPlugin.prototype.handleBeforePasteEvent = function (fragment, sanitizingOption) {
        var _this = this;
        var range = this.editor.getSelectionRange();
        if (!range.collapsed) {
            this.checkRemoveEntityForRange(null /*rawEvent*/);
        }
        var entityElements = roosterjs_editor_dom_1.toArray(fragment.querySelectorAll(EntityInfo_1.getEntitySelector()));
        if (entityElements.length > 0) {
            var knownIds_1 = EntityInfo_1.getAllEntityIds(this.editor);
            entityElements.forEach(function (element) {
                var entity = getEntityFromElement_1.default(element);
                if (entity) {
                    element.className = EntityInfo_1.serializeEntityInfo(_this.editor, entity.type, entity.isReadonly, entity.id, knownIds_1);
                }
            });
            Array.prototype.push.apply(sanitizingOption.additionalAllowedCssClasses, EntityInfo_1.ALLOWED_CSS_CLASSES);
        }
    };
    EntityPlugin.prototype.handleContentChangedEvent = function (resetAll) {
        var _this = this;
        this.knownEntityElements = resetAll
            ? []
            : this.knownEntityElements.filter(function (node) { return _this.editor.contains(node); });
        this.editor.queryElements(EntityInfo_1.getEntitySelector(), function (element) {
            if (_this.knownEntityElements.indexOf(element) < 0) {
                _this.knownEntityElements.push(element);
                tryTriggerEntityEvent_1.default(_this.editor, element, 0 /* NewEntity */);
            }
        });
    };
    EntityPlugin.prototype.handleExtractContentWithDomEvent = function (root) {
        var _this = this;
        roosterjs_editor_dom_1.toArray(root.querySelectorAll(EntityInfo_1.getEntitySelector())).forEach(function (element) {
            element.removeAttribute('contentEditable');
            tryTriggerEntityEvent_1.default(_this.editor, element, 8 /* ReplaceTemporaryContent */);
        });
    };
    EntityPlugin.prototype.checkRemoveEntityForRange = function (event) {
        var _this = this;
        var editableEntityElements = [];
        var selector = EntityInfo_1.getEntitySelector();
        this.editor.queryElements(selector, 1 /* OnSelection */, function (element) {
            if (element.isContentEditable) {
                editableEntityElements.push(element);
            }
            else {
                tryTriggerEntityEvent_1.default(_this.editor, element, 6 /* Overwrite */, event);
            }
        });
        // For editable entities, we need to check if it is fully or partially covered by current selection,
        // and trigger different events;
        if (editableEntityElements.length > 0) {
            var inSelectionEntityElements_1 = this.editor.queryElements(selector, 2 /* InSelection */);
            editableEntityElements.forEach(function (element) {
                var isFullyCovered = inSelectionEntityElements_1.indexOf(element) >= 0;
                tryTriggerEntityEvent_1.default(_this.editor, element, isFullyCovered ? 6 /* Overwrite */ : 7 /* PartialOverwrite */, event);
            });
        }
    };
    return EntityPlugin;
}());
exports.default = EntityPlugin;
/**
 * IE will show a resize border around the readonly content within content editable DIV
 * This is a workaround to remove it by temporarily move focus out of editor
 */
var workaroundSelectionIssueForIE = roosterjs_editor_dom_1.Browser.isIE
    ? function (editor) {
        editor.runAsync(function () {
            var workaroundButton = editor.getCustomData('ENTITY_IE_FOCUS_BUTTON', function () {
                var button = editor.getDocument().createElement('button');
                button.style.overflow = 'hidden';
                button.style.position = 'fixed';
                button.style.width = '0';
                button.style.height = '0';
                button.style.left = '0';
                button.style.top = '-1000px';
                button.onblur = function () {
                    button.style.display = 'none';
                };
                editor.insertNode(button, {
                    position: 4 /* Outside */,
                });
                return button;
            });
            workaroundButton.style.display = '';
            var range = editor.getDocument().createRange();
            range.setStart(workaroundButton, 0);
            try {
                window.getSelection().removeAllRanges();
                window.getSelection().addRange(range);
            }
            catch (_a) { }
        });
    }
    : function () { };
//# sourceMappingURL=EntityPlugin.js.map